import { ActivatedRoute, Router } from '@angular/router';
import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { finalize } from 'rxjs/operators';

import { BasePage } from '../../base.page';
import { ContractPage } from '../contract.page';
import { GetClientLocalStorageUseCase } from '../../../usecases/get-client-local-storage.use-case';
import { LocalStorage } from '../../../client/helpers/local-storage';
import { MainRoutes } from '../../../main-routes.enum';
import { ParentEvents } from '../../../utils/parent-events.service';
import { UpdateFirstHolderUseCase } from '../../../../core';

@Component({
    templateUrl: './contract-landing.page.html',
    styleUrls: ['./contract-landing.page.scss'],
})
export class ContractLandingPage extends BasePage implements AfterViewInit, OnInit, OnDestroy {
    constructor(
        parentEvents: ParentEvents,
        private contractPage: ContractPage,
        private getClientLocalStorageUseCase: GetClientLocalStorageUseCase,
        private localStorage: LocalStorage,
        private renderer: Renderer2,
        private route: ActivatedRoute,
        private router: Router,
        private updateFirstHolderUseCase: UpdateFirstHolderUseCase
    ) {
        super(parentEvents);
        contractPage.hideHeaderInfo();
    }

    ngOnInit() {
        this.renderer.addClass(document.body, 'bg-landing');
        this.checkContinue();
    }

    private checkContinue() {
        this.route.queryParams.subscribe((params) => {
            if ('continue' in params && String(params.continue) === '1') {
                this.getClientLocalStorageUseCase
                    .bind()
                    .pipe(finalize(() => this.localStorage.clear()))
                    .subscribe((transaction) => {
                        if (transaction.isSuccess) {
                            transaction.data.disabled = true;
                            transaction.data.preload = true;

                            this.updateFirstHolderUseCase.bind({ client: transaction.data }).subscribe((transactionUpdate) => {
                                if (transactionUpdate.isSuccess) {
                                    this.router.navigateByUrl(MainRoutes.NEW_CONTRACT_PARTICIPANTS);
                                }
                            });
                        }
                    });
            } else {
                this.localStorage.clear();
            }
        });
    }

    ngOnDestroy() {
        this.contractPage.showHeaderInfo();
        this.renderer.removeClass(document.body, 'bg-landing');
    }

    onClick() {
        this.router.navigateByUrl(MainRoutes.NEW_CONTRACT_NATURE);
    }
}
